// @flow

export const RECEIVE_FILTERED_ASSORTMENT: 'listo/assortment/RECEIVE_FILTERED_ASSORTMENT' = 'listo/assortment/RECEIVE_FILTERED_ASSORTMENT';
export const RECEIVE_ASSORTMENT: 'listo/assortment/RECEIVE_ASSORTMENT' = 'listo/assortment/RECEIVE_ASSORTMENT';
export const ADD_TERM_FILTER: 'listo/assortment/ADD_TERM_FILTER' = 'listo/assortment/ADD_TERM_FILTER';
export const RECEIVE_FACETS: 'listo/assortment/RECEIVE_FACETS' = 'listo/assortment/RECEIVE_FACETS';
export const REMOVE_TERM_FILTER: 'listo/assortment/REMOVE_TERM_FILTER' = 'listo/assortment/REMOVE_TERM_FILTER';
export const UPDATE_RANGE_FILTER: 'listo/assortment/UPDATE_RANGE_FILTER' = 'listo/assortment/UPDATE_RANGE_FILTER';
export const REMOVE_TERM_LABEL: 'listo/assortment/REMOVE_TERM_LABEL' = 'listo/assortment/REMOVE_TERM_LABEL';
export const REMOVE_RANGE_FILTER: 'listo/assortment/REMOVE_RANGE_FILTER' = 'listo/assortment/REMOVE_RANGE_FILTER';
export const RESET_FILTERS: 'listo/assortment/RESET_FILTERS' = 'listo/assortment/RESET_FILTERS';
export const UPDATE_SORT: 'listo/assortment/UPDATE_SORT' = 'listo/assortment/UPDATE_SORT';
export const HYDRATE_FILTERS: 'listo/assortment/HYDRATE_FILTERS' = 'listo/assortment/HYDRATE_FILTERS';
export const ADD_CUSTOM_FILTER: 'listo/assortment/ADD_CUSTOM_FILTER' = 'listo/assortment/ADD_CUSTOM_FILTER';
export const REMOVE_CUSTOM_FILTER: 'listo/assortment/REMOVE_CUSTOM_FILTER' = 'listo/assortment/REMOVE_CUSTOM_FILTER';

export default null;
